import { render, staticRenderFns } from "./401.vue?vue&type=template&id=230878a3"
import script from "./401.vue?vue&type=script&lang=ts"
export * from "./401.vue?vue&type=script&lang=ts"
import style0 from "./401.vue?vue&type=style&index=0&id=230878a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports